import React, {useEffect, useState, useCallback} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import DateObject from "react-date-object";
import Select from 'react-select';
import CloseButton from 'react-bootstrap/CloseButton';
import ProductsTable from "./productTable";
import AddProductModal from "./addProductModal";
import Modal from 'react-bootstrap/Modal';
import { apiClient } from '../../components/api/ApiClient';
import JalaliDatePicker from '../../components/common/JalaliDatePicker';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian_cal from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const requiredProductField = {
    Zero_type: ['finalDate', 'branch', 'buyerType'],
    First_type: ['finalDate', 'branch', 'buyerType'],
    Second_type: ['finalDate', 'branch', 'buyerType'],
    Third_type: ['finalDate', 'branch', 'buyerType'],
    First: [
        'productId', 'name', 'measurement', 'amount', 'currency', 'unitPrice', 'priceBeforeSale',
        'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice', 'otherTaxP', 'otherLegalP', 'totalPrice'],
    Second: [
        'foreignNum', 'productId', 'name', 'measurement', 'currency', 'currencyAmount', 'currencyPrice',
        'priceBeforeSale', 'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice',
        'otherTaxS', 'otherTaxR', 'otherTaxP', 'otherLegalS', 'otherLegalR',
        'otherLegalP', 'totalPrice', 'diffRialCurrency', 'taxSource',],
    Third: [
        'productId', 'name', 'measurement', 'amount', 'currency', 'unitPrice', 'priceBeforeSale',
        'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice', 'otherTaxS',
        'otherTaxR', 'otherTaxP', 'otherLegalS', 'otherLegalR', 'otherLegalP',
        'constructionFee', 'sellerProfit', 'commission', 'sumCSC', 'totalPrice'],
    Fourth: [
        'productId', 'name', 'measurement', 'amount', 'currency', 'unitPrice', 'priceBeforeSale',
        'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice', 'otherTaxS',
        'otherTaxR', 'otherTaxP', 'otherLegalS', 'otherLegalR', 'otherLegalP',
        'totalPrice'],
    Fifth: [
        "subId", 'productId', 'name', 'measurement', 'amount', 'currency', 'unitPrice', 'priceBeforeSale',
        'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice', 'otherTaxS',
        'otherTaxR', 'otherTaxP', 'otherLegalS', 'otherLegalR', 'otherLegalP',
        'totalPrice'],
    Sixth: [
        'foreignNum', 'productId', 'name', 'measurement', 'amount', 'currency', 'unitPrice', 'priceBeforeSale',
        'salePrice', 'priceAfterSale', 'taxPercent', 'taxPrice', 'otherTaxS',
        'otherTaxR', 'otherTaxP', 'otherLegalS', 'otherLegalR', 'otherLegalP',
        'totalPrice'],
    Seventh: [
        'productId', 'name', 'measurement', 'amount', 'weight', 'currency', 'unitPrice',
        'currencyPrice', 'rialValue', 'currencyValue', 'taxPercent', 'taxPrice',
        'otherTaxP', 'otherLegalP', 'totalPrice', 'diffRialCurrency', 'saleNoticeNum', 'saleNoticeDate'],
    Eighth: [
        'productId', 'productDetail', 'ladingBill', 'originCountry', 'originCity',
        'destinationCountry', 'destinationCity', 'senderNationalCode', 'receiverNationalCode',
        'shippingNum', 'driverNationalCode', 'ladingBillType'
    ],
    Eleventh: [
        'productId', 'name', 'measurement', 'amount', 'currency',
        'priceAfterSale', 'taxPercent', 'taxPrice', 'totalPrice'
    ]

}

function CorrectionInvoice(mode) {
    const correctMode = mode?.mode || mode
    const PaymentOptions = [
        {value: 'cheque', label: 'چک'},
        {value: 'barter', label: 'تهاتر'},
        {value: 'cash', label: 'وجه نقد'},
        {value: 'pos', label: 'پوز'},
        {value: 'online_payment', label: 'درگاه پرداخت اینترنتی'},
        {value: 'card_to_card', label: 'کارت به کارت'},
        {value: 'transfer', label: 'انتقال به حساب'},
        {value: 'other', label: 'سایر'},
    ]
    const {id, target} = useParams();
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [inputErrors, setInputErrors] = useState({});
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [userConfigure, setUserConfigure] = useState(null);

    const [lastInvoiceDate, setLastInvoiceDate] = useState();
    const [invoiceNum, setInvoiceNum] = useState(null)

    const [finalDate, setFinalDate] = useState(null);
    const [invoiceAlgo, setInvoiceAlgo] = useState('First');
    const [finalFaDate, setFinalFaDate] = useState(null);
    const [paymentType, setPaymentType] = useState()
    const [cashPayment, setCashPayment] = useState();
    const [creditPayment, setCreditPayment] = useState();
    const [paymentDate, setPaymentDate] = useState(null);
    const [paymentFaDate, setPaymentFaDate] = useState(null);
    const [paymentPrice, setPaymentPrice] = useState(null);
    const [trackingNum, setTrackingNum] = useState(null);
    const [num17, setNum17] = useState(null);
    const [paymentSwitch, setPaymentSwitch] = useState(null);
    const [storeNum, setStoreNum] = useState(null);
    const [terminalNum, setTerminalNum] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [buyerCardNum, setBuyerCardNum] = useState(null);

    const [productItems, setProductItems] = useState([]);
    const [sumPriceBeforeSale, setSumPriceBeforeSale] = useState();
    const [sumSalePrice, setSumSalePrice] = useState();
    const [sumPriceAfterSale, setSumPriceAfterSale] = useState();
    const [sumTaxPrice, setSumTaxPrice] = useState();
    const [sumOtherTax, setSumOtherTax] = useState();
    const [sumTotalPrice, setSumTotalPrice] = useState();
    const [sumWeight, setSumWeight] = useState();
    const [sumRialValue, setSumRialValue] = useState();
    const [sumCurrencyValue, setSumCurrencyValue] = useState();
    const [vppSum, setVppSum] = useState();

    const [showAddProducts, setShowAddProducts] = useState(false);
    const handleCloseAddProducts = () => setShowAddProducts(false);
    const [toast, setToast] = useState({ show: false, message: '', type: 'info' });
        
    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => setToast({ ...toast, show: false }), 5000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    const showToast = (message, type = 'info') => setToast({ show: true, message, type });

    const handleFieldChange = useCallback((setter, fieldName, onlyPositive = false, maxDigits = null, maxDecimals = null) => (e) => {
        let newValue = e.target.value;
        if (paymentType === 'mixed') {
            const total = parseInt(sumTotalPrice) || 0;

            if (fieldName === 'cashPayment') {
                const cash = parseInt(newValue || 0);
                const adjustedCash = Math.min(cash, total);
                const adjustedCredit = total - adjustedCash;

                newValue = adjustedCash.toString();
                setCreditPayment(adjustedCredit.toString());
            }

            if (fieldName === 'creditPayment') {
                const credit = parseInt(newValue || 0);
                const adjustedCredit = Math.min(credit, total);
                const adjustedCash = total - adjustedCredit;

                newValue = adjustedCredit.toString();
                setCashPayment(adjustedCash.toString());
            }
        }

        if (onlyPositive && Number(newValue) < 0) {
            return;
        }
        setter(newValue);
        setInputErrors((prevErrors) => {
            if (prevErrors[fieldName]) {
                return {...prevErrors, [fieldName]: ""};
            }
            return prevErrors;
        });
    }, []);
    const handleChangeSelect = (selectedOption, fieldName) => {
        if (fieldName === "ladingBillType") {
            // setLadingBillType(selectedOption.value);
            setInputErrors((prevErrors) => {
                if (prevErrors["ladingBillType"]) {
                    return {...prevErrors, ladingBillType: ""};
                }
                return prevErrors;
            });
        } else if (fieldName === "paymentMethod") {
            setPaymentMethod(selectedOption.value);
            setInputErrors((prevErrors) => {
                if (prevErrors["paymentMethod"]) {
                    return {...prevErrors, paymentMethod: ""};
                }
                return prevErrors;
            });
        }
    };
    const handleOpenProductModalForEdit = (product, index) => {
        console.log(product);
        setSelectedProduct({product: product, index: index,});
        setShowAddProducts(true);
    };
    const handleUpdateProduct = (updatedProduct) => {
        const {index} = updatedProduct;
        setProductItems(prevProducts =>
            prevProducts.map((product, i) =>
                i === index ? updatedProduct : product
            )
        );
    };
    const selectStyle = {
        control: (provided) => ({
            ...provided,
            borderRadius: '7px',
            direction: 'rtl',
            border: '2px solid black',
            ':hover': {
                border: '2px solid black',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            color: 'black',
            backgroundColor: state.isSelected ? 'lightgrey' : 'white',
            ':hover': {
                backgroundColor: state.isSelected ? 'lightgrey' : 'lightblue'
            }
        }),
    }

    function toValidDateObject(input) {
        if (input instanceof DateObject && input.isValid) {
            return input;
        }
        if (typeof input === 'object' && input !== null && typeof input.year === 'number') {
            try {
                const dateObj = new DateObject(input);
                if (dateObj.isValid) return dateObj;
            } catch (e) {
                console.error(e);
            }
        }
        if (typeof input === 'string') {
            const jsDate = new Date(input);
            const dateObj = new DateObject({date: jsDate, calendar: gregorian});
            if (dateObj.isValid) return dateObj;
        }
        return null;
    }

    const handleDateChange = (value, fieldName) => {
        const finalValue = toValidDateObject(value);
        console.log(typeof finalValue);
        if (finalValue?.isValid) {
            const formattedValue = finalValue.format("HH:mm YYYY/MM/DD");
            const faDate = new DateObject({
                date: finalValue,
                calendar: persian,
            });
            const geDate = faDate.convert(gregorian, gregorian_en).format("HH:mm YYYY/MM/DD")

            if (fieldName === "final") {
                setInputErrors((prev) => ({...prev, finalDate: ""}));
                const now = new DateObject({calendar: gregorian, locale: gregorian_en, format: "HH:mm YYYY/MM/DD"});
                const geDateObj = new DateObject({
                    date: geDate,
                    format: "HH:mm YYYY/MM/DD",
                    calendar: gregorian,
                    locale: gregorian_en
                });
                if (geDateObj > now) {
                    setInputErrors((prev) => ({
                        ...prev,
                        finalDate: 'تاریخ انتخاب شده نباید از زمان حال بزرگتر باشد!',
                    }));
                    return;
                }
                if (geDateObj < lastInvoiceDate) {
                    setInputErrors((prev) => ({
                        ...prev,
                        finalDate: 'تاریخ انتخاب شده نباید از تاریخ اخرین صورتحساب کوچکتر باشد!',
                    }));
                    return;
                }
                setFinalFaDate(faDate)
                setFinalDate(geDate);
            } else if (fieldName === "payment") {
                setPaymentFaDate(formattedValue)
                setPaymentDate(geDate);
            }
        } else {
            if (fieldName === "final") {
                setFinalDate(null);
                setFinalFaDate(null);
            } else if (fieldName === "payment") {
                setPaymentDate(null);
                setPaymentFaDate(null);
            }
        }
    };
    const validateInvoiceFields = () => {
        const invoiceData = {
            invoiceNum,
            finalDate,
        };

        const requiredFields = ['invoiceNum', 'finalDate'];

        let errors = {};
        requiredFields.forEach((field) => {
            if (
                invoiceData[field] === null ||
                (typeof invoiceData[field] === 'string' && invoiceData[field].trim() === "")
            ) {
                errors[field] = "این فیلد الزامی است";
            }
        });

        setInputErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const buildInvoicePayload = () => ({
        invoiceNum,
        paymentType,
        finalDate,
        productItems,
        cashPayment,
        creditPayment,
        paymentDate,
        paymentPrice,
        trackingNum,
        num17,
        paymentSwitch,
        storeNum,
        terminalNum,
        paymentMethod,
        buyerCardNum,
        vppSum,
        sumWeight,
        sumPriceBeforeSale,
        sumSalePrice,
        sumPriceAfterSale,
        sumTaxPrice,
        sumOtherTax,
        sumTotalPrice,
        sumRialValue,
        sumCurrencyValue,
    });
    const sendInvoice = async () => {
        if (!validateInvoiceFields()) {
            showToast('فیلد های الزامی را پر کنید !', 'error')
            return;
        }
        const payload = buildInvoicePayload();
        try {
            const response = await apiClient('/invoice/api/invoice-correction/', {
                data: {id, ...payload},
                method: "POST",
            })
            showToast('صورتحساب شما با موفقیت ثبت شد.', 'success')
            navigate('/invoices/list/')
        } catch (e) {
            if (e.message) {
                if (e.message === 'referenced') {
                    showToast('این صورتحساب قبلاً مرجع فاکتور دیگری قرار گرفته است.', 'error')
                } else {
                    showToast(e.message, 'error');
                }
            } else {
                showToast('خطایی در ثبت صورتحساب رخ داد.', 'error');
            }
        }
    }
    const updateInvoice = async () => {
        if (!validateInvoiceFields()) {
            showToast('فیلد های الزامی را پر کنید !', 'error')
            return;
        }
        const payload = buildInvoicePayload();
        try {
            const response = await apiClient('/invoice/api/invoice-correction/', {
                data: {target, ...payload},
                method: "PATCH",
            })
            showToast('صورتحساب شما با موفقیت ثبت شد.', 'success')
            navigate('/invoices/list/')
        } catch (e) {
            if (e.message) {
                if (e.message === 'referenced') {
                    showToast('این صورتحساب قبلاً مرجع فاکتور دیگری قرار گرفته است.', 'error')
                } else {
                    showToast(e.message, 'error');
                }
            } else {
                showToast('خطایی در ثبت صورتحساب رخ داد.', 'error');
            }
        }
    }
    const formatFinalDate = (value) => {
        const finalValue = toValidDateObject(value);
        if (finalValue?.isValid) {
            const faDate = new DateObject({
                date: finalValue,
                calendar: persian,
            }).format("HH:mm YYYY/MM/DD")
            return faDate ;
        }
        return null;
    };
    const fetchUserConfig = async (typeOfInvoice, algoOfInvoice) => {
        try {
            const response = await apiClient('/user-preferences/api/invoice-config/', {
                params: {
                    typeOfInvoice,
                    algoOfInvoice
                }
            });
            let fieldsArray = response?.fields_config || response;
            if (!Array.isArray(fieldsArray) && fieldsArray && typeof fieldsArray === 'object') {
                fieldsArray = Object.entries(fieldsArray).map(
                    ([name, cfg]) => ({ name, ...cfg })
                );
            }
            if (Array.isArray(fieldsArray)) {
                const configObject = Object.fromEntries(
                    fieldsArray.map(({ name, ...rest }) => [name, rest])
                );
                setUserConfigure(configObject);
            }
        } catch (e) {
            console.error("Error fetching invoice config:", e);
        }
    };

    const getInvoice = async () => {
        try {
            setLoading(true)
            const response = await apiClient('/invoice/api/', {
                data: {invoiceId: id},
                method: "POST",
            })
            const invoice = response.data
            if (invoice) {
                const formattedFinalDate = formatFinalDate(invoice.finalDate);
                setInvoice({
                    ...invoice,
                    formattedFinalDate,
                });
                setInvoiceAlgo(invoice.invoiceAlgo)
                fetchUserConfig(invoice.invoiceType, invoice.invoiceAlgo)
                if (correctMode === 'create') {
                    setPaymentType(invoice.paymentType)
                    setCashPayment(invoice.cashPayment)
                    setCreditPayment(invoice.creditPayment)
                    setPaymentPrice(invoice.paymentPrice)
                    setTrackingNum(invoice.trackingNum)
                    setNum17(invoice.num17)
                    setPaymentSwitch(invoice.paymentSwitch)
                    setStoreNum(invoice.storeNum)
                    setTerminalNum(invoice.terminalNum)
                    setPaymentMethod(invoice.paymentMethod)
                    setBuyerCardNum(invoice.buyerCardNum)
                    if (invoice.productItems.length > 0) {
                        setProductItems(invoice.productItems)
                        setSumPriceBeforeSale(invoice.sumPriceBeforeSale)
                        setSumSalePrice(invoice.sumSalePrice)
                        setSumPriceAfterSale(invoice.sumPriceAfterSale)
                        setSumTaxPrice(invoice.sumTaxPrice)
                        setSumOtherTax(invoice.sumOtherTax)
                        setSumTotalPrice(invoice.sumTotalPrice)
                        setSumWeight(invoice.sumWeight)
                        setSumRialValue(invoice.sumRialValue)
                        setSumCurrencyValue(invoice.sumCurrencyValue)
                        setVppSum(invoice.vppSum)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }
    const getInvoiceItem = async () => {
        try {
            const response = await apiClient('/invoice/api/new-invoice/');
            if (correctMode == 'create') {
                setInvoiceNum(response.num);
            }
            const lastDate = toValidDateObject(response.lastDate);
            setLastInvoiceDate(lastDate)
        } catch (err) {
            console.error('Failed to fetch data:', err);
        }
    }
    useEffect(() => {
        const priceBeforeSale = productItems?.reduce((acc, item) => acc + parseFloat(item.priceBeforeSale || 0), 0) || null;
        const salePrice = productItems?.reduce((acc, item) => acc + parseFloat(item.salePrice || 0), 0) || null;
        const priceAfterSale = productItems?.reduce((acc, item) => acc + parseFloat(item.priceAfterSale || 0), 0) || null;
        const taxPrice = productItems?.reduce((acc, item) => acc + parseFloat(item.taxPrice || 0), 0) || null;
        const otherTax = productItems?.reduce((acc, item) => acc + parseFloat(item.otherTaxP + item.otherLegalP || 0), 0) || 0;
        const totalPrice = productItems?.reduce((acc, item) => acc + parseFloat(item.totalPrice || 0), 0) || null;
        const weight = productItems?.reduce((acc, item) => acc + parseFloat(item.weight || 0), 0) || null;
        const rialValue = productItems?.reduce((acc, item) => acc + parseFloat(item.rialValue || 0), 0) || null;
        const currencyValue = productItems?.reduce((acc, item) => acc + parseFloat(item.currencyValue || 0), 0) || null;
        const vppValue = productItems?.reduce((acc, item) => acc + parseFloat(item.vpp || 0), 0) || null;
        setSumPriceBeforeSale(Math.trunc(priceBeforeSale));
        setSumSalePrice(Math.trunc(salePrice));
        setSumPriceAfterSale(Math.trunc(priceAfterSale));
        setSumTaxPrice(Math.trunc(taxPrice));
        setSumOtherTax(Math.trunc(otherTax));
        setSumTotalPrice(Math.trunc(totalPrice));
        setSumWeight(weight);
        setSumRialValue(Math.trunc(rialValue));
        setSumCurrencyValue(Math.trunc(currencyValue));
        setVppSum(Math.trunc(vppValue));
        if (paymentType === 'cash') {
            setCashPayment(Math.trunc(totalPrice - otherTax - taxPrice))
        } else if (paymentType === 'credit') {
            setCreditPayment(Math.trunc(totalPrice - otherTax - taxPrice))
        }
    }, [productItems]);
    const getTargetInvoice = async () => {
        try {
            const response = await apiClient('/invoice/api/invoice-correction/', {
                data: {
                    target: target
                },
                method: "GET"
            });
            const data = response || response.data || response.data.data
            if (data) {
                setInvoiceNum(data.invoiceNum);
                setInvoiceAlgo(data.invoiceAlgo);
                fetchUserConfig(data.invoiceType, data.invoiceAlgo);
                handleDateChange(data.finalDate, 'final');
                setPaymentType(data.paymentType)
                setCashPayment(data.cashPayment)
                setCreditPayment(data.creditPayment)
                setPaymentPrice(data.paymentPrice)
                setTrackingNum(data.trackingNum)
                setNum17(data.num17)
                setPaymentSwitch(data.paymentSwitch)
                setStoreNum(data.storeNum)
                setTerminalNum(data.terminalNum)
                setPaymentMethod(data.paymentMethod)
                setBuyerCardNum(data.buyerCardNum)
                if (data.productItems.length > 0) {
                    setProductItems(data.productItems)
                    setSumPriceBeforeSale(data.sumPriceBeforeSale)
                    setSumSalePrice(data.sumSalePrice)
                    setSumPriceAfterSale(data.sumPriceAfterSale)
                    setSumTaxPrice(data.sumTaxPrice)
                    setSumOtherTax(data.sumOtherTax)
                    setSumTotalPrice(data.sumTotalPrice)
                    setSumWeight(data.sumWeight)
                    setSumRialValue(data.sumRialValue)
                    setSumCurrencyValue(data.sumCurrencyValue)
                    setVppSum(data.vppSum)
                }
            }
        } catch (err) {
            console.error(err);
        }
    }
    useEffect(() => {
        getInvoice();
        getInvoiceItem();
        if (correctMode != 'create' && target) {
            getTargetInvoice()
        }
    }, []);
    return (
        <div className='row'>
             {toast.show && (
                <div aria-live="polite" aria-atomic="true" className="position-fixed w-100 p-3" style={{ zIndex: 1060, top: 0, right: 0 }}>
                    <div className="toast-container position-absolute p-3" style={{ top: 0, left: 0 }}>
                        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header" style={{ direction: 'rtl' }}>
                                <img src="/assets/images/redesigned.png" className="rounded ms-2" alt="..." width="20" />
                                <strong className="me-auto ms-2">پیام سیستم</strong>
                                <button type="button" className="btn-close" onClick={() => setToast({ ...toast, show: false })}></button>
                            </div>
                            <div className="toast-body">{toast.message}</div>
                        </div>
                    </div>
                </div>
            )}
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <h5>صدور صورتحساب اصلاحی</h5>
                <button className="btn btn-outline-secondary" onClick={() => navigate("/invoices/list/")}>خروج</button>
            </div >
            <div>
                <div className="alert alert-warning mt-4" role="alert">
                    <p className="fw-bold mb-2">* نوع و الگوی صورتحساب، اقلام اطاعاتی مربوط به خریدار ، شناسه کالا/خدمت و نرخ مالیات بر
                        ارزش افزوده غیر قابل اصلاح بوده و برای اصلاح آنها میبایست صورتحساب مرجع ابطال و
                        صورتحساب جدید صادر گردد.
                    </p>
                </div>
                <div>
                    <div className="d-flex mb-4 justify-item-center border-top pt-3">
                        <h6 className="mb-0 ms-5">صورتحساب مورد نظر</h6>
                        <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                    </div>
                    <div className='table-responsive'>
                        {loading ? (
                            <div className="text-center p-5 bg-secondary-subtle border-7">
                                <p className='fs-2'>در حال بارگذاری داده‌ها...</p>
                            </div>
                        ) : (
                            invoice ? (
                                <table className='table table-hover'>
                                    <thead>
                                    <tr>
                                        <th className='text-center'>شماره صورتحساب</th>
                                        <th className='text-center'>تاریخ و زمان صدور</th>
                                        <th className='text-center'>مبلغ فروش</th>
                                        <th className='text-center'>مبلغ ارزش افزوده</th>
                                        {['3', '2'].includes(invoice.buyerType) && (
                                            <th className='text-center'>شماره اقتصادی خریدار</th>
                                        )}
                                        {invoice.buyerType === '1' && (
                                            <th className="text-center">شناسنامه / کد ملی خریدار</th>
                                        )}
                                        {invoice.buyerType === '4' && (
                                            <th className="text-center">کد فراگیر اتباع غیر ایرانی خریدار</th>
                                        )}
                                        <th className='text-center'>عملیات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className='text-center'>{invoice.invoiceNum}</td>
                                        <td className='text-center'>{invoice.formattedFinalDate}</td>
                                        <td className='text-center'>{invoice.sumTotalPrice}</td>
                                        <td className='text-center'>{invoice.sumTaxPrice}</td>
                                        {['3', '2'].includes(invoice.buyerType) && (
                                            <td className='text-center'>{invoice.buyerEconomicNum}</td>
                                        )}
                                        {['1', '4'].includes(invoice.buyerType) && (
                                            <td className='text-center'>{invoice.buyerId}</td>
                                        )}
                                        <td className='text-center pointer'
                                            onClick={() => navigate(`/invoice/view/${id}`)}>
                                            مشاهده کامل
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            ) : (
                                <div className="alert alert-warning text-center mb-4">هیچ صورتحسابی موجود نیست.</div>
                            )
                        )}
                    </div>
                </div>
            </div>
            
            <div>
                <div className="d-flex mb-4 justify-item-center border-top pt-3">
                    <h6 className="mb-0 ms-5">اطلاعات تکمیلی</h6>
                    <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="invoiceNum" className="form-label">
                            شماره صورتحساب <span className="text-danger">*</span>
                        </label>
                        <input
                            id="invoiceNum"
                            type="number"
                            className="form-control"
                            value={invoiceNum ? invoiceNum : 'در حال محاسبه...'}
                            disabled={true}
                        />
                        {inputErrors.invoiceNum && (
                            <small className="text-danger">{inputErrors.invoiceNum}</small>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label for="finalDate" className="form-label">
                            تاریخ و زمان صدور صورتحساب <span className="text-danger">*</span>
                        </label>
                            <DatePicker
                                format="HH:mm YYYY/MM/DD"
                                inputClass="form-control"
                                style={{ display: 'block' }}
                                inputId="finalDate"
                                fieldName="finalDate"
                                calendar={persian_cal}
                                locale={persian_fa}
                                value={finalFaDate}
                                onChange={(value) => handleDateChange(value, "final")}
                                plugins={[
                                    <TimePicker position="bottom"/>
                                ]}
                                onClear={() => {
                                    setFinalFaDate(null);
                                    setFinalDate(null);
                                }}
                                containerStyle={{
                                        display: "block",
                                        width: "100%"
                                    }}
                            />
                        {inputErrors.finalDate && (
                            <small className="text-danger">{inputErrors.finalDate}</small>
                        )}
                    </div>
                </div>
            </div>
            
            <div>
                <div className={`mb-4 ${invoiceAlgo === 'Eighth' ? 'd-none' : ''}`}>
                    <div className="d-flex align-items-center mb-3 border-top pt-3">
                        <h6 className="mb-0">مشخصات کالا/خدمت</h6>
                        <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                    </div>
                    {productItems.length === 0 ? (
                        <div className="alert alert-warning text-center mb-4">هیچ کالا/خدمتی انتخاب نشده است.</div>
                    ) : (
                        <div className="d-flex flex-column">
                            <ProductsTable 
                                data={productItems}
                                onRowClick={(product, index) => handleOpenProductModalForEdit(product, index)}
                            />
                            <Modal 
                                show={showAddProducts} 
                                onHide={handleCloseAddProducts} 
                                size="xl"
                                aria-labelledby="contained-modal-title-vcenter" 
                                centered
                                scrollable
                            >
                                <Modal.Header dir='rtl'>
                                    <Modal.Title>
                                        {selectedProduct ? "ویرایش کالا/خدمت" : "اضافه کردن کالا/خدمت"}
                                    </Modal.Title>
                                    <CloseButton className='mx-0 me-auto' onClick={() => handleCloseAddProducts()}/>
                                </Modal.Header>
                                <AddProductModal
                                    activeAlgo={invoiceAlgo}
                                    requiredFields={requiredProductField[invoiceAlgo]}
                                    onUpdate={handleUpdateProduct}
                                    onClose={() => {
                                        setShowAddProducts(false);
                                        setSelectedProduct(null)
                                    }}
                                    product={selectedProduct}
                                    mode={2}
                                    invoiceAlgo={invoiceAlgo}
                                    userConfigure={userConfigure}
                                />
                            </Modal>
                            <div className="rtl d-flex mb-4 justify-item-center">
                                <h6 className="mb-0 ms-5">مجموع هزینه ها</h6>
                                <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                            </div>
                            <div className="d-flex flex-wrap gap-4 mb-4 px-3 rtl">
                                {sumWeight != null && sumWeight > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع وزن خالص:</span>
                                        <h6 className="mb-0 fw-bold">{sumWeight}</h6>
                                    </div>
                                }
                                {sumPriceBeforeSale != null && sumPriceBeforeSale > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع مبلغ قبل از کسر تخفیف:</span>
                                        <h6 className="mb-0 fw-bold">{sumPriceBeforeSale}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumSalePrice != null && sumSalePrice > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع تخفیفات:</span>
                                        <h6 className="mb-0 fw-bold text-danger">{sumSalePrice}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumPriceAfterSale != null && sumPriceAfterSale > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع مبلغ پس از کسر تخفیف:</span>
                                        <h6 className="mb-0 fw-bold">{sumPriceAfterSale}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumTaxPrice != null && sumTaxPrice > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع مالیات بر ارزش افزوده:</span>
                                        <h6 className="mb-0 fw-bold">{sumTaxPrice}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumOtherTax != null && sumOtherTax > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع سایر مالیات، عوارض و وجوه قانونی:</span>
                                        <h6 className="mb-0 fw-bold">{sumOtherTax}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumCurrencyValue != null && sumCurrencyValue > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع ارزش ارزی:</span>
                                        <h6 className="mb-0 fw-bold">{sumCurrencyValue}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumRialValue != null && sumRialValue > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع ارزش ریالی:</span>
                                        <h6 className="mb-0 fw-bold">{sumRialValue}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {vppSum != null && vppSum > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">مجموع سهم مالیات از پرداخت:</span>
                                        <h6 className="mb-0 fw-bold">{vppSum}</h6>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                                {sumTotalPrice != null && sumTotalPrice > 0 &&
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="fw-bold fs-6">مجموع کل صورتحساب:</span>
                                        <h5 className="mb-0 fw-bold text-success">{sumTotalPrice}</h5>
                                        <small className="text-muted">ریال</small>
                                    </div>
                                }
                            </div>
                        </div>
                    )}
                </div>
                
                <div className="rtl d-flex mb-4 justify-item-center border-top pt-3">
                    <h6 className="mb-0">اطلاعات پرداخت</h6>
                    <div className="bg-black flex-grow-1 m-auto me-5 header-hr"></div>
                </div>

                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-3 mb-4">
                    <div>
                        <label htmlFor="cashPayment" className="form-label">
                            مبلغ پرداختی نقدی {paymentType !== 'credit' && <span className="text-danger">*</span>}
                        </label>
                        <input
                            id="cashPayment"
                            type="number"
                            className="form-control"
                            value={cashPayment}
                            onChange={handleFieldChange(setCashPayment, 'cashPayment', true)}
                            disabled={paymentType === 'mixed' ? false : true}
                        />
                        {inputErrors.cashPayment && (
                            <small className="text-danger">{inputErrors.cashPayment}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="creditPayment" className="form-label">
                            مبلغ نسیه {paymentType !== 'cash' && <span className="text-danger">*</span>}
                        </label>
                        <input
                            id="creditPayment"
                            type="number"
                            className="form-control"
                            value={creditPayment}
                            onChange={handleFieldChange(setCreditPayment, 'creditPayment', true)}
                            disabled={paymentType === 'mixed' ? false : true}
                        />
                        {inputErrors.creditPayment && (
                            <small className="text-danger">{inputErrors.creditPayment}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="paymentDate" className="form-label">
                            تاریخ و زمان پرداخت
                        </label>
                        <JalaliDatePicker
                            id="paymentDate"
                            value={paymentFaDate}
                            onChange={(date) => handleDateChange(date, 'payment')}
                            onClear={() => {
                                setPaymentFaDate(null);
                                setPaymentDate(null);
                            }}
                            showTime={true}
                        />
                        {inputErrors.paymentDate && (
                            <small className="text-danger">{inputErrors.paymentDate}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="paymentPrice" className="form-label">
                            مبلغ پرداختی
                        </label>
                        <input
                            id="paymentPrice"
                            type="number"
                            className="form-control"
                            value={paymentPrice}
                            onChange={handleFieldChange(setPaymentPrice, 'paymentPrice', true)}
                        />
                        {inputErrors.paymentPrice && (
                            <small className="text-danger">{inputErrors.paymentPrice}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="trackingNum" className="form-label">
                            شماره پیگیری/شماره مرجع
                        </label>
                        <input
                            id="trackingNum"
                            type="number"
                            className="form-control"
                            value={trackingNum}
                            onChange={handleFieldChange(setTrackingNum, 'trackingNum', true)}
                        />
                        {inputErrors.trackingNum && (
                            <small className="text-danger">{inputErrors.trackingNum}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="num17" className="form-label">
                            مالیات موضوع ماده 17
                        </label>
                        <input
                            id="num17"
                            type="number"
                            className="form-control"
                            value={num17}
                            onChange={handleFieldChange(setNum17, 'num17', true)}
                        />
                        {inputErrors.num17 && (
                            <small className="text-danger">{inputErrors.num17}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="paymentSwitch" className="form-label">
                            شماره سوئیچ پرداخت
                        </label>
                        <input
                            id="paymentSwitch"
                            type="number"
                            className="form-control"
                            value={paymentSwitch}
                            onChange={handleFieldChange(setPaymentSwitch, 'paymentSwitch', true)}
                        />
                        {inputErrors.paymentSwitch && (
                            <small className="text-danger">{inputErrors.paymentSwitch}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="storeNum" className="form-label">
                            شماره پذیرنده فروشگاهی
                        </label>
                        <input
                            id="storeNum"
                            type="number"
                            className="form-control"
                            value={storeNum}
                            onChange={handleFieldChange(setStoreNum, 'storeNum', true)}
                        />
                        {inputErrors.storeNum && (
                            <small className="text-danger">{inputErrors.storeNum}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="terminalNum" className="form-label">
                            شماره پایانه
                        </label>
                        <input
                            id="terminalNum"
                            type="number"
                            className="form-control"
                            value={terminalNum}
                            onChange={handleFieldChange(setTerminalNum, 'terminalNum', true)}
                        />
                        {inputErrors.terminalNum && (
                            <small className="text-danger">{inputErrors.terminalNum}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="paymentMethod" className="form-label">
                            روش پرداخت
                        </label>
                        <Select
                            inputId="paymentMethod"
                            options={PaymentOptions}
                            styles={selectStyle}
                            onChange={(selectedOption) => handleChangeSelect(selectedOption, 'paymentMethod')}
                            value={PaymentOptions.find(option => option.value === paymentMethod)}
                        />
                        {inputErrors.paymentMethod && (
                            <small className="text-danger">{inputErrors.paymentMethod}</small>
                        )}
                    </div>
                    
                    <div>
                        <label htmlFor="buyerCardNum" className="form-label">
                            شماره کارت پرداخت کننده صورتحساب
                        </label>
                        <input
                            id="buyerCardNum"
                            type="number"
                            className="form-control"
                            value={buyerCardNum}
                            onChange={handleFieldChange(setBuyerCardNum, 'buyerCardNum', true)}
                        />
                        {inputErrors.buyerCardNum && (
                            <small className="text-danger">{inputErrors.buyerCardNum}</small>
                        )}
                    </div>
                </div>
            </div>
            
            <div className="mt-2 d-flex justify-content-start gap-2 mb-2">
                {correctMode === 'create' ? (
                    <button 
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => sendInvoice()}
                    >
                        ثبت
                    </button>
                ) : correctMode === 'edit' ? (
                    <button 
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => updateInvoice()}
                    >
                        ثبت
                    </button>
                ) : null}
                <button
                    className="btn btn-secondary btn-sm"
                    type="button"
                    onClick={() => navigate('/invoices/list/')}
                >
                    خروج
                </button>
            </div>
        </div>
        </div>
    )


}

export default CorrectionInvoice;